export class SearchFilter {
    constructor(docType: string, labelKey: string, resultCount: number) {
        this.docType = docType;
        this.labelKey = labelKey;
        this.resultCount = resultCount;
    }

    public docType: string;

    public labelKey: string;
    
    public resultCount: number;
}